import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from 'apps/new-web/views/component';
import createLayout from 'apps/new-web/views/pages/create-layout';
import { connect } from 'react-redux';
import reducers from './reducers';
import MarketingNav from 'apps/new-web/views/components/header';
import ErrorMessage from 'apps/new-web/views/components/error-message';
import LoginForm from 'apps/new-web/views/components/login';
import I18n from 'apps/new-web/views/components/i18n';
import FacebookLogin from 'apps/new-web/views/components/login/components/facebook-login';
import GoogleLogin from 'apps/new-web/views/components/login/components/google-login';
import RememberMe from 'apps/new-web/views/components/login/components/remember-me';
import { actionCreators } from './actions';

export class PureLoginPage extends BaseComponent {
  static get propTypes() {
    return {
      facebookAppId: PropTypes.string.isRequired,
      googleClientId: PropTypes.string.isRequired,
      layout: PropTypes.object.isRequired,
      loginWithFacebook: PropTypes.func.isRequired,
      loginWithGoogle: PropTypes.func.isRequired,
      rememberMe: PropTypes.bool.isRequired,
      setRememberMe: PropTypes.func.isRequired,
      thirdPartyLoginError: PropTypes.string
    };
  }

  static getAdditionalHeadTags() {
    return `<meta name="description" content="${ I18n.translate('Log in to your [ifit] membership account. Gain access to personal trainers, [hiit] workouts, ab workouts, cardio workouts, cycling classes, yoga classes, & more.', { ifit: 'iFIT', hiit: 'HIIT' }, 'Invites user to log in to iFIT and join virtual workouts on their equipment. Ab workouts are abdominal workouts.')}" />
            <link rel="preconnect" href="https://fonts.googleapis.com">
            <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
            <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@500&display=swap" rel="stylesheet">`;
  }

  render() {
    const {
      facebookAppId,
      googleClientId,
      login,
      loginWithFacebook,
      loginWithGoogle,
      rememberMe,
      setRememberMe,
      thirdPartyLoginError
    } = this.props;
    const { mediaType } = this.props.layout;

    return (
      <div className="login-page">
        <MarketingNav mediaType={ mediaType } />
        <main id="main-content">
          <div className="login-page-container">
            <div className="social-container">
              <FacebookLogin appId={ facebookAppId } loginWithFacebook={ loginWithFacebook } />
              <GoogleLogin clientId={ googleClientId } loginWithGoogle={ loginWithGoogle } />
            </div>
            { thirdPartyLoginError &&
              <p className="third-party-error">
                <ErrorMessage>{ thirdPartyLoginError }</ErrorMessage>
              </p>
            }
            <div className="or-split">
              <I18n args={{ spanStart: '<span class="sr-only">&nbsp;', spanEnd: '</span>' }} desc="Log in with social OR email and password">Or[spanStart] login with your email address.[spanEnd]</I18n>
            </div>
            <LoginForm
              handleSignIn={ login }
              hideTitle
            />
            <div className="login-sub-actions">
              <RememberMe
                checked={ rememberMe }
                handleChange={ setRememberMe }
              />
              <a href="/login/forgot-password"><I18n>Forgot your password?</I18n></a>
            </div>
          </div>
        </main>
      </div>
    );
  }
}

const LoginPage = connect(
  state => ({
    layout: state.layout,
    facebookAppId: state.facebookAppId,
    googleClientId: state.googleClientId,
    rememberMe: Boolean(state.rememberMe),
    thirdPartyLoginError: state.thirdPartyLoginError
  }), {
    login: actionCreators.login,
    loginWithFacebook: actionCreators.loginWithFacebook,
    loginWithGoogle: actionCreators.loginWithGoogle,
    setRememberMe: actionCreators.setRememberMe
  }
)(PureLoginPage);

export default createLayout(LoginPage, reducers);
